define('lq/events/actions/refreshLoggedInUserCommand',[
    'lq/events/actions/eventAction',
    'lq/guidChecker'
], function (EventAction, guidChecker) {
    'use strict';

    function RefreshLoggedInUserCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(RefreshLoggedInUserCommand, EventAction);

    RefreshLoggedInUserCommand.typeName = 'RefreshLoggedInUserCommand';

    RefreshLoggedInUserCommand.prototype.getBatchType = function () {
        return this.eventData.cookieOnly || this.parameterMatchesCurrentUser() ? EventAction.DO_NOT_BATCH : EventAction.COMMAND_BATCH;
    };

    RefreshLoggedInUserCommand.prototype.createEventActionRequest = function () {
        if (this.eventData.cookieOnly || this.parameterMatchesCurrentUser()) return undefined;

        return {
            eventActionType: 'RefreshLoggedInUser',
            command: this.eventData.command
        };
    };

    RefreshLoggedInUserCommand.prototype.execute = function (continuation) {
        if (!this.eventData.cookieOnly) {
            if (this.parameterMatchesCurrentUser()) {
                this.refresh(continuation);
            } else {
                continuation();
            }
        } else {
            this.refresh(continuation);
        }
    };

    RefreshLoggedInUserCommand.prototype.parameterMatchesCurrentUser = function () {
        return guidChecker.areEqual(
            this.piping.parameters.getValue(this.eventData.targetUserIdParameter),
            this.piping.parameters.getValue('CurrentUser')
        )
    };

    RefreshLoggedInUserCommand.prototype.refresh = function (continuation) {
        this.piping.dispatcher.dispatch('LicquidAction/RefreshCurrentUser')
            .then(function () {
                continuation();
            });
    };

    return RefreshLoggedInUserCommand;
});
